export default {
  privat: {
    breadcrumbHome: 'Home',
    breadcrumbSolutions: 'Solutions',
    breadcrumbCurrent: 'Home & property',
    hero: {
      eyebrow: 'Private customers',
      title: 'Your home in view – properly planned and discreetly installed',
      lead: 'Whether a family home, condominium or apartment building – we protect your privacy and property with tailored camera systems. Without scaremongering, without excessive surveillance.',
    },
    useCases: {
      title: 'Solutions for your home',
      lead: 'Every house is different. We consider your individual access points, lighting conditions and wishes – and plan the right surveillance points.',
      items: {
        '0': { title: 'Front door & entrance area', desc: 'The front door is the most important surveillance point. We plan a discreet camera with good detail resolution – for facial recognition and parcel monitoring.' },
        '1': { title: 'Driveway & garage', desc: 'Number-plate recognition, vehicle monitoring and access control – with weatherproof outdoor cameras and night vision.' },
        '2': { title: 'Garden & terrace', desc: 'Monitor garden access points, terraces and side entrances. Weatherproof cameras with wide angle for the overview.' },
        '3': { title: 'Side entrances & cellar door', desc: 'Often overlooked, but a popular access point. Additional cameras at side entrances close the last gap.' },
        '4': { title: 'Apartment buildings', desc: 'Entrance area, stairwell and outdoor areas – planned with privacy in mind, with privacy masking and signage.' },
        '5': { title: 'Smartphone access', desc: 'Live view and playback on your phone – whether at home or on the go. We set everything up.' },
      },
    },
    night: {
      eyebrow: 'Night vision',
      title: 'Security that never sleeps',
      lead: 'Most incidents happen in the dark. With special day/night cameras you keep the overview even at night – in black and white with infrared or even in colour.',
      items: {
        '0': { title: 'Infrared night vision', desc: 'Sharp images even in complete darkness – up to 30 m range depending on the model.' },
        '1': { title: 'Colour night', desc: 'Colour images at night instead of black and white – thanks to highly sensitive Starlight sensors.' },
        '2': { title: 'Intelligent lighting', desc: 'White-light LEDs on movement as a deterrent and at the same time for colour recordings.' },
      },
    },
    privacy: {
      eyebrow: 'Data protection',
      title: 'Protect private zones, respect rights',
      lead: 'Data protection is particularly important for private video surveillance. From the very beginning we ensure:',
      list: {
        '0': 'No capture of public roads or neighbouring property',
        '1': 'Privacy masking directly in the camera or recorder',
        '2': 'Signage at entrances (legally recommended)',
        '3': 'Local storage – your data stays with you',
        '4': 'Access rights and user management for apartment buildings',
      },
      note: 'Note: The legal admissibility of video surveillance depends on the individual case. We advise you, but do not replace legal advice.',
    },
    cta: {
      title: 'Protect what matters to you',
      lead: 'A non-binding initial conversation shows you the possibilities for your home – transparently and without pressure.',
      primary: 'Arrange a consultation',
      secondary: 'Start the Camera Planner',
    },
  },
};